const CEFR_TOKENS: Record<string, { bg: string; text: string }> = {
  A1: { bg: 'var(--cefr-a1-bg)', text: 'var(--cefr-a1-text)' },
  A2: { bg: 'var(--cefr-a2-bg)', text: 'var(--cefr-a2-text)' },
  B1: { bg: 'var(--cefr-b1-bg)', text: 'var(--cefr-b1-text)' },
  B2: { bg: 'var(--cefr-b2-bg)', text: 'var(--cefr-b2-text)' },
  C1: { bg: 'var(--cefr-c1-bg)', text: 'var(--cefr-c1-text)' },
  C2: { bg: 'var(--cefr-c2-bg)', text: 'var(--cefr-c2-text)' },
}

interface Props {
  level: string | null | undefined
  size?: 'sm' | 'md'
}

export default function CEFRBadge({ level, size = 'sm' }: Props) {
  if (!level) return null
  const key = level.toUpperCase()
  const tokens = CEFR_TOKENS[key] ?? { bg: 'var(--bg-secondary)', text: 'var(--text-secondary)' }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: size === 'sm' ? '0 8px' : '2px 10px',
        height: size === 'sm' ? 20 : 24,
        borderRadius: 'var(--radius-pill)',
        backgroundColor: tokens.bg,
        color: tokens.text,
        fontSize: size === 'sm' ? 11 : 13,
        fontWeight: 700,
        letterSpacing: '0.02em',
        flexShrink: 0,
        userSelect: 'none',
      }}
    >
      {key}
    </span>
  )
}
